<template>
    <component :is="tag" style="height: 100%">
        <slot
            :campaign="campaign"
            :contact="contact"
            :is-proposal-preview="isProposalPreview"
            :proposal="proposal"
            :campaign-fields="campaignFields"
            :proposalSteps="proposalSteps"
            :current-proposal-step="currentProposalStep"
            :errors="errors"
            :errorMessage="errorMessage"
            :is-loading="isLoading"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-proposal-step="patchProposalStep"
            :complete-proposal="completeProposal"
            :isLoading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :is-patching-proposal="isPatchingProposal"
            :error-message="errorMessage"
            :file-upload-url="fileUploadUrl"
            :file-upload-headers="uploadHeaders"
            :proposal-files="proposalFiles"
            :is-file-uploading="isFileUploading"
            :handle-file-upload="handleFileUpload"
            :handle-file-delete="handleFileDelete"
            :discount-codes="discountCodes"
            :affiliate-link="affiliateLink"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin   from "./mixins/BaseProposalStepMixin";
    import ProposalFilesProviderMixin from "./mixins/ProposalFilesProviderMixin";
    import UploadMixin from "./mixins/UploadMixin";

    export default {
        name: 'ProposalsProvider',
        mixins: [
            BaseProposalStepMixin,
            ProposalFilesProviderMixin,
            UploadMixin,
        ],
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposal(true),
                        this.loadCampaignFields(),
                        this.loadDiscountCodes(),
                        this.loadAffiliateLink(),
                    ]);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>
